module.exports = __webpack_public_path__ + "static/img/top2.cf6b15b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top2.png
// module id = 5TG9
// module chunks = 1